<template>
    <AppCard class="flex flex-col items-start">
        <TyreAlignedCard
            :product="product"
            :showBorder="false"
            :badge="badge"
        >
            <template v-slot:header>
                <h3 class="block font-bold text-lg mb-4">{{ badge.name }}</h3>
            </template>
        </TyreAlignedCard>
        <div v-if="badge.excerpt !== null" v-html="badge.excerpt"></div>
        <div v-if="reviewLink" class="pl-2 w-full h-full text-center md:w-auto my-4">
            <AppButton :href="reviewLink" class="!justify-start !items-start bg-red text-white">Watch Steve's Review</AppButton>
        </div>
    </AppCard>
</template>

<script>
import AppCard from "@/Components/AppCard";
import TyreAlignedCard from "@/Components/Products/Tyres/TyreAlignedCard";
import AppButton from "@/Components/AppButton";
export default {
    name: "WinnersCard",
    components: {AppButton, TyreAlignedCard, AppCard},
    props:
    {
        product: Object,
        badge: Object,
        reviewLink: String
    }
}
</script>

<style scoped>

</style>
